import { Component, OnInit, Input, Injectable } from "@angular/core";
import { CommonService } from "../service/common.service";
import { MailService } from "../service/mail.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  NgbInputDatepicker,
  NgbDatepickerI18n,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { ATemplateSaveModalComponent } from "./a-template-save-modal.component";
const I18N_VALUES = {
  ja: {
    weekdays: ["月", "火", "水", "木", "金", "土", "日"],
    months: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
  },
};
@Injectable()
export class I18n {
  language = "ja";
}
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) {
    super();
  }
  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
}

@Component({
  selector: "a-mailtask-create-app",
  templateUrl: "./a-mailtask-create.component.html",
  styleUrls: ["a-mailtask-create.component.css"],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
  ],
})
export class MailTaskCreateComponent {
  @Input() eventId: number;
  @Input() mailTemplate: any[];
  @Input() taskType: any[];
  @Input() sendFiles: any[];
  @Input() sendPersons: any[];

  selectList: any = [];

  constructor(
    public commonService: CommonService,
    private mailService: MailService,
    public activeModal: NgbActiveModal
  ) {}

  selectedTaskId: number = null;
  taskStartDate: any = null;
  taskEndDate: any = null;
  execDate: any = null;
  limit_days: string = null;

  ret: any = {
    // status: "",
    select_tqc_id: "",
    answer_list: [],
  };

  //起動時処理
  ngOnInit(): void {
    //モーダル内セレクトボックスの初期値設定
    for(let i=0; this.taskType.length>i; i++){
      if(this.taskType[i].id != "9"){
        this.taskType[i].disabled = false;
      }else{
        if(this.sendPersons.length>0){
          this.taskType[i].disabled = false;
        }else{
          this.taskType[i].disabled = true;
        }
      }
    }
    var i = this.sendPersons;
  }
  save(): void {
    let param = {
      id: null,
      t_event_id: this.eventId,
      t_question_category_id: null,
      m_event_task_type_id: this.selectedTaskId,
      m_mail_template_id: this.mailTemplate["m_mail_template_id"],
      startDate: this.taskStartDate,
      endDate: this.taskEndDate,
      execDate: this.execDate,
      limit_days: this.limit_days,
      send_files: this.sendFiles,
      send_persons: this.sendPersons,
    };
    this.mailService.saveTask(param).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.commonService.modalOpens(10001, (modalresult) => {
            if (modalresult == "OK") {
              this.ret.status = "OK";
              this.activeModal.close(this.ret);
            }
          });
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {}
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      }
    );
  }
  checkList(): boolean {
    if (
      this.selectedTaskId == null ||
      this.taskStartDate == null ||
      this.taskEndDate == null ||
      this.execDate == null
    ) {
      return true;
    } else {
      if (this.checkDate(1)) {
        return true;
      } else {
        if (this.checkTime()) {
          return true;
        } else {
          if(this.checkNumber()){
            return true;
          } else {
            return false;
          }
        }
      }
    }
  }
  checkDate(mode: number): boolean {
    switch (mode) {
      //reply大小
      case 1:
        if (this.taskStartDate == null || this.taskEndDate == null) {
          return false;
        } else {
          if (
            this.commonService.exchangeDateFormat2(this.taskStartDate) >
            this.commonService.exchangeDateFormat2(this.taskEndDate)
          ) {
            return true;
          } else {
            return false;
          }
        }
    }
  }
  checkTime(): boolean{
    let match = this.execDate.match(/^([01][0-9]|2[0-3])([0-5][0-9])$/);
    if(!match){
      return true;
    } else {
      return false;
    }
  }
  checkNumber(): boolean {
    if(this.limit_days!=null){
      let num = this.limit_days;
      let match = num.match(/^[0-9]+$/);
      if(!match) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  replaceNumber():void {
    if(this.limit_days == ""){
      this.limit_days = null;
    }
  }
  modalCloseOK() {
    this.ret.status = "OK";
    this.activeModal.close(this.ret);
  }
  //キャンセル時
  modalCloseCancel() {
    this.ret.status = "Cancel";
    this.activeModal.close(this.ret);
  }
  /**
   * 切り替えるDatePicker以外を閉じながら、
   * toggleで表示非表示を切り替える
   *
   * @param selectDp 切り替えるDatePicker
   * @param subDp 閉じるDatePicker
   */
  toggleDate(selectDp: NgbInputDatepicker, subDp: NgbInputDatepicker): void {
    selectDp.toggle();
    subDp.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/a0106-mail/a-mailtask-create.component.ts